import { render, staticRenderFns } from "./RegistrationPage.vue?vue&type=template&id=1202058e&scoped=true&"
import script from "./RegistrationPage.vue?vue&type=script&lang=ts&"
export * from "./RegistrationPage.vue?vue&type=script&lang=ts&"
import style0 from "./RegistrationPage.vue?vue&type=style&index=0&id=1202058e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1202058e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VStepper } from 'vuetify/lib/components/VStepper';
import { VStepperContent } from 'vuetify/lib/components/VStepper';
import { VStepperItems } from 'vuetify/lib/components/VStepper';
installComponents(component, {VCard,VContainer,VStepper,VStepperContent,VStepperItems})
